export const enUSOauth = {
  title: 'Authorize access',
  subtitle: '{{clientName}} wants to connect to your Nomi account',
  permissionsIntro: 'This app will be able to:',
  permLists: 'View and edit household lists (add, check off, and remove items)',
  permFinance: 'View bills, expenses, and financial summaries (read-only)',
  permAgenda: 'View family agenda events (read-only)',
  actingAs: 'Signed in as {{name}}',
  approve: 'Authorize',
  deny: 'Deny',
  loading: 'Loading…',
  invalidRequest: 'Invalid or expired authorization request.',
  submitError: 'Failed to record your decision. Please try again.',
} as const;
